// extracted by mini-css-extract-plugin
module.exports = {"navbar-tm":"TimeMachineNavbar_navbar-tm__zIXR1","scroller":"TimeMachineNavbar_scroller__BeKXg","epochs":"TimeMachineNavbar_epochs__Bc676"};